import { UntypedFormGroup } from '@angular/forms';

import moment from 'moment-timezone';

import { IDaySchedule, IException, IRawSchedule } from './models';
import {
  fromBackendFormatDay,
  fromBackendFormatWeek,
  getTimestamps,
  getTimestampsWeek,
  scheduleIsInsideDefaultSchedule
} from './functions';

function fromFormFormat(schedule: IValue): Array<Array<IRawSchedule>> {
  let hoursAdditionalSchedule = [];
  if (schedule.closed) {
    hoursAdditionalSchedule.push([]);
  } else {
    const hasTwoRanges = schedule?.hoursFirstValueSecondArray
      && (typeof schedule.hoursFirstValueSecondArray || typeof schedule.hoursSecondValueSecondArray) !== 'string';
    const nextDay = schedule.nextDay;
    let hours = [schedule.hoursFirstValueFirstArray,
      {...schedule.hoursSecondValueFirstArray, addOneDay: nextDay && !hasTwoRanges}];
    if (hasTwoRanges) {
      hours.push(schedule.hoursFirstValueSecondArray,
        {...schedule.hoursSecondValueSecondArray, addOneDay: nextDay})
    }
    hoursAdditionalSchedule.push(hours);
  }
  return hoursAdditionalSchedule;
}

interface IHours {
  hours: number;
  minutes: number;
}

export interface IValue {
  closed: boolean;
  date: string;
  hoursFirstValueFirstArray: IHours;
  hoursFirstValueSecondArray: IHours;
  hoursSecondValueFirstArray: IHours;
  hoursSecondValueSecondArray: IHours;
  nextDay: boolean;
}

export function exceptionValidator(schedules: any[], schIndex) {
  return (formGroup: UntypedFormGroup) => {
    const value: IValue = formGroup.value;
    if (!schedules.length) {
      return null;
    }
    const isDefaultSchedule = schedules[schIndex]?.default;

    if (isDefaultSchedule) {
      if (typeof value.hoursFirstValueFirstArray === 'string' && value.hoursFirstValueFirstArray === '') {
        value.hoursFirstValueFirstArray = { hours: 0, minutes: 0 };
      }

      if (typeof value.hoursSecondValueFirstArray === 'string' && value.hoursSecondValueFirstArray === '') {
        value.hoursSecondValueFirstArray = { hours: 23, minutes: 59 };
      }
    }

    const currentException = fromFormFormat(value);
    const currentExceptionTimestamps = getTimestamps(currentException);

    const hoursOtherSchedules = isDefaultSchedule
      ? schedules.slice(1).map(schedule => fromBackendFormatWeek(schedule))
      : [fromBackendFormatWeek(schedules[0])];
    const timestampOtherSchedules = hoursOtherSchedules
      .map(hours => getTimestampsWeek(hours));

    let exceptionsList: Array<Array<IException>> = null;

    if (isDefaultSchedule) {
      //collect other exceptions of remaining schedules
      exceptionsList = schedules.reduce((otherExceptions, currentSchedule) => {
        if (!currentSchedule.default) {
          otherExceptions.push(currentSchedule.exceptions)
        }
        return otherExceptions;
      }, []);
    } else {
      exceptionsList = [schedules[0].exceptions]
    }

    const exceptionsOtherSchedules: Array<Array<{exception: IDaySchedule, date: string}>> = exceptionsList.map((exceptions) => {
      return exceptions.map((exception) => ({
        exception: getTimestamps(fromBackendFormatDay(exception)),
        date: exception.date,
      }));
    });

    let otherExceptionsOnSameDate = exceptionsOtherSchedules
      .map(es => es
        .filter(e => value.date === e.date));

    const weekday = (moment.utc(value.date, 'MMM DD, YYYY').weekday() + 6) % 7;
    const errorResult = isDefaultSchedule ? { conflictInsideDefaultException: true } : { conflictInsideAdditionalException: true };

    if (isDefaultSchedule) {
      for (let i = 0; i < timestampOtherSchedules.length; ++i) {
        if (otherExceptionsOnSameDate[i]?.length) {
          if (!scheduleIsInsideDefaultSchedule(
            currentExceptionTimestamps,
            otherExceptionsOnSameDate[i][0].exception
          )) {
            return errorResult;
          }
        }
      }
      return null;
    } else {
      const defaultException =
        otherExceptionsOnSameDate.reduce((acc, e) => acc.concat(e), []);
      if (defaultException.length) {
        // The default schedule has an exception on the same date
        return scheduleIsInsideDefaultSchedule(
          defaultException[0].exception,
          currentExceptionTimestamps)
          ? null
          : errorResult;
      } else {
        // Compare to the default schedule
        return scheduleIsInsideDefaultSchedule(
          timestampOtherSchedules[0][weekday],
          currentExceptionTimestamps)
          ? null
          : errorResult;
      }
    }
  }
}
